export default __webpack_public_path__ + "static/media/calendar.7ba67cfa.svg";